import z from 'zod';

export interface CboRecordDto {
  id: string;
  googlePlaceId: string | null;
  name: string;
  contactName: string | null;
  phoneNumber: string | null;
  email: string | null;
  websiteUrl: string | null;
  streetAddress: string | null;
  addressDetails: string | null;
  city: string | null;
  state: string | null;
  zipcode: string | null;
  formattedAddress: string | null;
  placeTypes: string[] | null;
  categoryLabel: string | null;
  firstEnteredByUserId: string;
  lastUpdatedByUserId: string;
  createdAt: number;
  updatedAt: number | null;
}

export const UpsertCboRecordRequestSchema = z.object({
  googlePlaceId: z.string().optional().nullable(),
  name: z.string().min(1),
  contactName: z.string().optional().nullable(),
  phoneNumber: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  websiteUrl: z.string().optional().nullable(),
  streetAddress: z.string().optional().nullable(),
  addressDetails: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  state: z.string().optional().nullable(),
  zipcode: z.string().optional().nullable(),
  formattedAddress: z.string().optional().nullable(),
  placeTypes: z.array(z.string()).optional().nullable(),
  categoryLabel: z.string().optional().nullable(),
});

export type UpsertCboRecordRequestDto = z.infer<typeof UpsertCboRecordRequestSchema>;

export const RecordCboUsageRequestSchema = z.object({
  needId: z.number().int().positive(),
  actionId: z.number().int().positive().optional().nullable(),
  needResourceInteractionId: z.string().optional().nullable(),
});

export type RecordCboUsageRequestDto = z.infer<typeof RecordCboUsageRequestSchema>;

export const RecentCboRecordsQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(10).optional().default(3),
});

export type RecentCboRecordsQueryDto = z.infer<typeof RecentCboRecordsQuerySchema>;

export interface CboReportingRowDto {
  cboName: string;
  cboProgramAddress: string | null;
  cboProgramCity: string | null;
  cboProgramState: string | null;
  cboProgramZipCode: string | null;
  cboProgramEmailAddress: string | null;
  cboProgramPhoneNumber: string | null;
  memberId: string;
  needId: number;
  enteredByUserId: string;
  usedAt: number;
  cboRecordId: string;
}

export const CboReportingQuerySchema = z.object({
  memberId: z.string().uuid().optional(),
  needId: z.coerce.number().int().positive().optional(),
  enteredByUserId: z.string().uuid().optional(),
  usedAfter: z.coerce.number().optional(),
  usedBefore: z.coerce.number().optional(),
});

export type CboReportingQueryDto = z.infer<typeof CboReportingQuerySchema>;
